module.exports = __webpack_public_path__ + "static/media/app_store_color.d5752bc6.png";